import { render, staticRenderFns } from "./messagenewBox.vue?vue&type=template&id=e0e19b9c&scoped=true&"
import script from "./messagenewBox.vue?vue&type=script&lang=js&"
export * from "./messagenewBox.vue?vue&type=script&lang=js&"
import style0 from "./messagenewBox.vue?vue&type=style&index=0&id=e0e19b9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e19b9c",
  null
  
)

export default component.exports